import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { signup } from '../actions/authActions';

export default function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(s => s.auth);
  const [form, setForm] = useState({ name: '', email: '', password: '' });

  const submit = async (e) => {
    e.preventDefault();
    const res = await dispatch(signup(form.email, form.password, form.name));
    if (res.ok) navigate('/dashboard');
  };

  return (
    <section className="section narrow">
      <h1>Create your account</h1>
      <form className="auth-form" onSubmit={submit}>
        <label>Name<input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></label>
        <label>Email<input required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></label>
        <label>Password<input required type="password" minLength={8} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} /></label>
        <button className="btn-primary" type="submit" disabled={loading}>{loading ? 'Creating account…' : 'Sign up'}</button>
        {error && <p className="status error">{error}</p>}
      </form>
      <p className="muted">Already have an account? <Link to="/login">Sign in</Link></p>
    </section>
  );
}
